import * as v from '@badrap/valita'
import { regionSchema } from 'src/regions'
import { createStorageCategory } from 'src/storage'

const createStorage = createStorageCategory('session', 'AUTH')

export const savedTokens = createStorage(
  'tokens',
  v.union(
    v.null(),
    v.object({
      username: v.string(),
      organization: v.string(),
      region: regionSchema,
      idToken: v.string(),
      accessToken: v.string(),
      refreshToken: v.string(),
      expires: v.number(),
    }),
  ),
)
